import { DASHBOARD_TYPES, LOCAL_STORAGE_KEYS } from 'constants/global';

const { DASHBOARD_TYPE } = LOCAL_STORAGE_KEYS;

export const saveToStorage = (name, data) => {
    localStorage.setItem(name, JSON.stringify(data));
};

export const getFromStorage = (name) => {
    const value = localStorage.getItem(name);
    return value && value !== 'undefined' ? JSON.parse(value) : null;
};

export const removeFromStorage = (name) => {
    localStorage.removeItem(name);
};

export const setUser = (user) => {
    user &&
        saveToStorage(
            DASHBOARD_TYPE,
            user?.role === 'super admin' || user?.role === 'finance'
                ? (getFromStorage(DASHBOARD_TYPE) ?? DASHBOARD_TYPES.WHOLESALE)
                : user?.role === DASHBOARD_TYPES.LOGISTICS
                  ? user.role
                  : DASHBOARD_TYPES.WHOLESALE
        );
    saveToStorage('user', user);
    window.dispatchEvent(new Event('storage'));
};

export const getUser = () => getFromStorage('user');
